import { Button, Text } from '@chakra-ui/react';
import {
  ModalOrDrawerBody,
  ModalOrDrawerFooter,
} from '@ui/components/ModalOrDrawer';
import usePendingVno from '@ui/hooks/usePendingVno';
import { useTranslations } from '@ui/i18n';

import { GardenVaultSelection } from '../GardenVaultSelection';
import { GardenVnoAllocationBody } from '../GardenVnoAllocationInfo';
import { useGardenHarvestDrawer } from './useGardenHarvestDrawer';
import { useGardenHarvest } from './utils';

export const DefaultContent = () => {
  const t = useTranslations();

  const gardenType = useGardenHarvestDrawer((s) => s.gardenType);
  const vaultType = useGardenHarvestDrawer((s) => s.vaultType);
  const setVaultType = useGardenHarvestDrawer((s) => s.setVaultType);

  const { pendingVno } = usePendingVno(gardenType);

  const { mutate: doHarvest } = useGardenHarvest();

  return (
    <>
      <ModalOrDrawerBody alignItems="center">
        <Text textStyle="h3" textAlign="center">
          {t('{coin} allocation', {
            coin: 'VNO',
          })}
        </Text>
        <GardenVnoAllocationBody
          vnoAmount={pendingVno}
          intoWalletTitle={t('Receive in wallet')}
          into12MonthTitle={t('Lock for 12 months')}
          mt="36px"
        />
        <Text mt="36px">{t('Where do you want to lock your VNO?')}</Text>
        <GardenVaultSelection
          mt="6px"
          vaultType={vaultType}
          onChange={setVaultType}
        />
      </ModalOrDrawerBody>
      <ModalOrDrawerFooter>
        <Button
          disabled={!vaultType}
          onClick={() => {
            doHarvest();
          }}
        >
          {t('Confirm')}
        </Button>
      </ModalOrDrawerFooter>
    </>
  );
};
